import Vue from 'vue';
import Router from 'vue-router';
import restrictedRoute from './restrictedRoute';
import nonRestrictedRoutes from './nonRestrictedRoutes';
import PageNotFound from '../components/PageNotFound';
import App from '../App';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: App,
      children: [restrictedRoute],
    },
    ...nonRestrictedRoutes,
    {
      path: '*',
      name: 'page-not-found',
      component: PageNotFound,
      props: route => ({ routeName: route.params.pathMatch }),
    },
  ],
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }

    if (to.hash) {
      return {
        selector: to.hash.replace('#', '#scroll-'),
        behavior: 'smooth',
      };
    }

    return { x: 0, y: 0 };
  },
});
